var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWatchIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#3781EF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M17.202 9.163c.192.23.298.528.298.837 0 .31-.106.608-.298.838C15.988 12.25 13.225 15 10 15s-5.988-2.75-7.202-4.162A1.3 1.3 0 0 1 2.5 10c0-.31.106-.608.298-.838C4.012 7.75 6.775 5 10 5s5.988 2.75 7.202 4.163"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#3781EF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
})));
export default SvgWatchIcon;